import useSWR from "swr";
import { message } from "antd";
import * as Sentry from "@sentry/nextjs";
import { CrossSellResponse } from "../steps/cross-sell";
import { useAuthToken } from "../passwordless-auth";
import { useFetcher } from "./";
import { api } from "@dreambigger/shared/src/api/acquire";
import { crossSellPaths } from "./cross-sell";

export default function useCrossSell(
  applicationId: string | undefined,
  financialInstitutionId: string
) {
  const tokenHelper = useAuthToken(financialInstitutionId);
  const { fetchWithToken } = useFetcher(api, financialInstitutionId);

  const { data, isValidating, error } = useSWR<CrossSellResponse>(
    applicationId && !tokenHelper.jwtIsExpired()
      ? [
          crossSellPaths.getProductsByApplication(applicationId),
          tokenHelper.getJwtToken(),
        ]
      : null,
    fetchWithToken,
    {
      onError: (error) => {
        console.error("Error loading cross-sell products:", error);
        console.error("Error details:", error.response?.data || error.message);
        message.error("Unable to load product offers");
        Sentry.captureException(error);
      },
      // Cache for reasonable time since cross-sell data doesn't change frequently
      dedupingInterval: 60000, // 1 minute
      revalidateOnFocus: false,
    }
  );

  return {
    data,
    isValidating,
    error,
  };
}
